<div dropdown keyboard-nav="true" class="dropdown">
  <button
    dropdownToggle
    class="btn btn-default btn-responsive dropdown-toggle qa-edit-dd"
    [ngClass]="[isEdit ? '' : 'btn-lg']"
    data-bs-toggle="dropdown"
    id="edit-list-btn"
    type="button"
  >
    <ng-container i18n="@@editMenu-btn-edit">Edit</ng-container>
  </button>
  <ul *dropdownMenu class="dropdown-menu">
    <li *ngIf="editMenuVisibility.canEditList">
      <button
        class="dropdown-item qa-edit-list-details"
        (click)="openEditListDetailsModal()"
        [class.disabled]="disableEtagInvalidatingActions"
        [disabled]="disableEtagInvalidatingActions"
        type="button"
        i18n="@@editMenu-btn-editListDetails"
      >
        Edit list details
      </button>
    </li>
    <li *ngIf="editMenuVisibility.canCreateList">
      <a
        class="dropdown-item qa-copy-list"
        [href]="copyListUrl"
        target="_top"
        i18n="@@editMenu-btn-copyList"
        >Copy list</a
      >
    </li>
    <li *ngIf="editMenuVisibility.canArchiveList">
      <button
        class="dropdown-item qa-archive-list"
        (click)="openArchiveListModal()"
        type="button"
        i18n="@@editMenu-btn-archiveList"
      >
        Archive list
      </button>
    </li>
    <li *ngIf="editMenuVisibility.canDeleteList">
      <button
        class="dropdown-item qa-delete-list"
        (click)="openDeleteListModal()"
        type="button"
        i18n="@@editMenu-btn-deleteList"
      >
        Delete list
      </button>
    </li>
    <ng-container
      *ngIf="
        !isCourseFlowTenancy &&
        (editMenuVisibility.canReviewList ||
          editMenuVisibility.canRequestReview)
      "
    >
      <li class="dropdown-divider" role="presentation"></li>
      <li
        *ngIf="editMenuVisibility.canRequestReview"
        [class.disabled]="disableEtagInvalidatingActions"
      >
        <button
          class="dropdown-item qa-request-review"
          (click)="requestReview()"
          [disabled]="disableEtagInvalidatingActions"
          type="button"
          i18n="@@editMenu-btn-requestReview"
        >
          Request review
        </button>
      </li>
      <li
        *ngIf="editMenuVisibility.canReviewList && editableList.activeReviewUrl"
      >
        <a
          class="dropdown-item qa-review-list"
          [href]="editableList.activeReviewUrl"
          target="_blank"
          rel="noopener noreferrer"
          i18n="@@editMenu-btn-reviewList"
        >
          Review list
        </a>
      </li>
      <li *ngIf="editMenuVisibility.canReviewList">
        <button
          class="dropdown-item qa-review-history"
          (click)="reviewHistory()"
          type="button"
          i18n="@@editMenu-btn-reviewHistory"
        >
          Review history
        </button>
      </li>
    </ng-container>
    <ng-container
      *ngIf="
        editMenuVisibility.canInviteListPublishers ||
        editMenuVisibility.canAssignListOwners
      "
    >
      <li class="dropdown-divider" role="presentation"></li>
      <li *ngIf="editMenuVisibility.canAssignListOwners">
        <button
          class="dropdown-item qa-assign-list-owners"
          (click)="assignListOwners()"
          [class.disabled]="disableEtagInvalidatingActions"
          [disabled]="disableEtagInvalidatingActions"
          type="button"
          i18n="@@editMenu-btn-assignListOwner"
        >
          Assign list owner
        </button>
      </li>
      <li *ngIf="editMenuVisibility.canInviteListPublishers">
        <a
          class="dropdown-item qa-invite-publisher"
          [href]="inviteListPublishersUrl"
          target="_top"
          i18n="@@editMenu-btn-inviteListPublishers"
        >
          Invite list publishers
        </a>
      </li>
    </ng-container>
    <ng-container
      *ngIf="editMenuVisibility.canModifyHierarchyAndStudentNumbers"
    >
      <li class="dropdown-divider" role="presentation"></li>
      <li>
        <button
          class="dropdown-item qa-student-numbers-and-hierarchy"
          (click)="editStudentNumbersAndHierarchy()"
          [class.disabled]="disableEtagInvalidatingActions"
          [disabled]="disableEtagInvalidatingActions"
          type="button"
          i18n="@@editMenu-btn-hierarchyAndstudentNumbers"
        >
          Hierarchy and student numbers
        </button>
      </li>
    </ng-container>
  </ul>
</div>
